import { MessageUI } from "./types";
import { formatMessageTime } from "@/utils/formatMessageTime";

export function ChatMessageIn({ message }: { message: MessageUI }) {
  return (
    <>
      <div className="message-bubble bg-[#6B8E5A] text-white rounded-2xl rounded-tr-md px-4 py-3 shadow-sm">
        <div className="text-lg md:text-base leading-relaxed whitespace-pre-wrap">
          {message.content}
        </div>
        <div className="text-xs text-white/70 mt-1">
          {formatMessageTime(message.timestamp)}
        </div>
      </div>
    </>
  );
}
